<template>

<div class="login">

  <form @submit.prevent="login">
  <h3>ACCEDER</h3>
  <div class="form-group">
    <label>Correo</label>
    <input type="text" required class="form-control" placeholder="Ingresa el correo" v-model="model.username">
  </div>
  <div class="form-group">
    <label>Contraseña</label>
    <input type="password" required v-model="model.password" class="form-control" placeholder="Ingresa la contraseña">

  </div>

  <div class="form-group">


    <input type="submit" class="btn btn-info" value="Acceder"/>
  </div>

  </form>

</div>



</template>
<script>


import api from '@/util/api.js';

export default{
  name:'Login',
  data(){

    return {
      
        model:{
          username:'',
          password:''
      }

    }


  },

  methods:{

    login(){


      const data=new FormData();

      data.append('username',this.model.username);
      data.append('password',this.model.password);

      api.post('/user/login',data).then((response)=>{

        if(response.data.done){

          localStorage.setItem('token',response.data.token);

          this.$router.push('/dashboard');


        }else{
          alert(response.data.message);

        }


      });
      

    }
  }


}

</script>
<style lang="scss">

.login{background:#35495E !important;display:flex !important;align-items: center;justify-content: center;height: 100%;width: 100%;position:absolute};
.login form{
  min-width: 300px;

  h3,label{color:#fff}
}

</style>
